import * as React from 'react';
import { Alert, Box, Snackbar, TextField, Typography, Checkbox, Tooltip } from '@mui/material';
import { inputStyles } from './style';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import useAppContext from '../../../hooks/useAppContext/useAppContext';

interface InputUIProps {
  className?: string;
  variant?: 'filled' | 'standard' | 'outlined' | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  value: string;
  isLoaded: boolean;
  label: string;
  isCharactersLimited?: boolean;
  success?: 'success' | 'error' | 'primary' | 'secondary' | 'info' | 'warning';
  warning?: 'success' | 'error' | 'primary' | 'secondary' | 'info' | 'warning';
  checked: boolean;
}
export function InputUI(props: InputUIProps): JSX.Element {
  const {
    variant = 'outlined',
    isLoaded,
    value,
    onChange,
    title,
    label,
    isCharactersLimited,
    success = 'success',
    warning = 'warning',
    checked,
  } = props;
  const { inputContent } = inputStyles;
  const { t } = useTranslation();
  const { hasDevice } = useAppContext();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState<string>('');
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = () => {
    setOpenSnackbar(true);
  };

  useMemo(() => {
    if (!!value && !isLoaded) {
      setMessage(t(hasDevice ? 'wrong-URL-plus' : 'wrong-URL'));
      handleSnackbarOpen();
    } else {
      handleSnackbarClose();
    }
  }, [isLoaded, value, hasDevice, t]);

  return (
    <Box component="form" sx={inputContent} noValidate autoComplete="off">
      <Typography>{title}</Typography>

      <TextField
        color={isLoaded ? success : warning}
        value={value}
        size={'small'}
        id="outlined-basic"
        label={t(`${label}`)}
        variant={variant}
        inputProps={isCharactersLimited ? { maxLength: 20 } : {}}
        onChange={onChange}
      />
      <Snackbar className="snack-bar" open={openSnackbar} autoHideDuration={4000} onClose={handleSnackbarClose}>
        <Alert className="alert" elevation={6} variant="filled" severity="info">
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
